<p-multiSelect
  #multiselect
  *ngIf="visible"
  [(ngModel)]="value"
  [inputId]="id"
  [name]="name"
  [tabindex]="tabindex"
  [appendTo]="appendTo"
  [autofocusFilter]="autofocusFilter"
  [autoZIndex]="autoZIndex"
  [baseZIndex]="baseZIndex"
  [dataKey]="dataKey"
  [disabled]="disabled"
  [displaySelectedLabel]="displaySelectedLabel"
  [dropdownIcon]="dropdownIcon"
  [emptyFilterMessage]="emptyFilterMessage  | i18next"
  [filter]="filter"
  [filterMatchMode]="filterMatchMode"
  [filterValue]="filterValue"
  [filterBy]="filterBy"
  [filterPlaceHolder]="filterPlaceHolder  | i18next"
  [itemSize]="itemSize"
  [maxSelectedLabels]="maxSelectedLabels"
  [options]="options"
  [optionLabel]="optionLabel"
  [optionValue]="isObject ? null : optionValue"
  [optionDisabled]="optionDisabled"
  [overlayVisible]="overlayVisible"
  [panelStyle]="panelStyle"
  [placeholder]="placeholder  | i18next"
  [readonly]="readonly"
  [emptyMessage]="emptyMessage  | i18next"
  [resetFilterOnHide]="resetFilterOnHide"
  [scrollHeight]="scrollHeight"
  [selectedItemsLabel]="selectedItemsLabel"
  [selectionLimit]="selectionLimit"
  [showHeader]="showHeader"
  [showToggleAll]="showToggleAll"
  [style]="style"
  [styleClass]="styleClass"
  [virtualScroll]="virtualScroll"
  (onClick)="mxClick($event)"
  (onChange)="mxChange($event)"
  (onFilter)="mxFilter($event)"
  (onFocus)="mxFocus($event)"
  (onBlur)="mxBlur($event)"
  (onPanelShow)="mxPanelShow($event)"
  (onPanelHide)="mxPanelHide($event)"
>
  <ng-template pTemplate="selectedItems" let-values>
    <ng-container
      *ngIf="useSelectedItemsTemplate; else elseBlock"
      [ngTemplateOutlet]="selectedItemsTemplateRef"
      [ngTemplateOutletContext]="{ $implicit: values }"
    >
    </ng-container>
    <ng-template #elseBlock>
      <span *ngIf="values && values.length !== 0"
        >{{ values?.length }} {{ "selected" | i18next }}</span
      >
      <div *ngIf="!values || values.length === 0">
        {{ "Select_please" | i18next }}
      </div>
    </ng-template>
  </ng-template>
  <ng-template *ngIf="useItemTemplate" pTemplate="item" let-value>
    <ng-container
      [ngTemplateOutlet]="itemTemplateRef"
      [ngTemplateOutletContext]="{ $implicit: value }"
    >
    </ng-container>
  </ng-template>
</p-multiSelect>
